import React from 'react';
import { TextStyled } from '@nike/nike-design-system-components';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const SecEmeaCutover = () => (
  <div style={{ paddingBottom: '10px', marginBottom: '12px' }}>
    <TextStyled bold appearance='body1'>
      <TranslatedCopy id='termsConditions.section.notice' />
    </TextStyled>
    <TextStyled>
      <TranslatedCopy id='outages.systemUpgrade.notice' />
    </TextStyled>
    <br />
    <TextStyled bold style={{ textDecoration: 'underline' }}>
      <TranslatedCopy id='outages.systemUpgrade.users.emea' />
    </TextStyled>
    <div style={{ lineHeight: '1.25' }}>
      <TextStyled bold display='inline'>
        <TranslatedCopy id='outages.systemUpgrade.date.november14' />
      </TextStyled>
      {' - '}
      <TranslatedCopy id='outages.systemUpgrade.time.17cet' />
    </div>
    <div style={{ lineHeight: '1.25', marginBottom: '8px' }}>
      <TranslatedCopy id='outages.systemUpgrade.finalReturnsDay.jan7' />
    </div>
    <div style={{ lineHeight: '1.25' }}>
      <TextStyled bold display='inline'>
        <TranslatedCopy id='outages.systemUpgrade.date.december20' />
      </TextStyled>
      {' - '}
      <TranslatedCopy id='outages.systemUpgrade.time.17cet' />
    </div>
    <div style={{ lineHeight: '1.25', marginBottom: '8px' }}>
      <TranslatedCopy id='outages.systemUpgrade.shop.jan6' />
    </div>
    <br />
    <TextStyled bold style={{ textDecoration: 'underline' }}>
      <TranslatedCopy id='outages.systemUpgrade.users.all' />
    </TextStyled>
    <div style={{ lineHeight: '1.25' }}>
      <TextStyled bold display='inline'>
        {new TranslatedCopy({ id: 'outages.systemUpgrade.date.december27' }).toString().replace('27', '29')}
      </TextStyled>
      {' - '}
      <TranslatedCopy id='outages.systemUpgrade.fullSiteOutage' />
    </div>
    <div style={{ lineHeight: '1.25' }}>
      <TranslatedCopy id='outages.systemUpgrade.fullSiteOutage.description' />
    </div>
    <br />
    <div style={{ lineHeight: '1.25' }}>
      <TextStyled bold display='inline'>
        {new TranslatedCopy({ id: 'outages.systemUpgrade.date.january5' }).toString().replace('5', '6')}
      </TextStyled>
      {' - '}
      <TranslatedCopy id='outages.systemUpgrade.time.8cet' />
    </div>
    <TranslatedCopy id='outages.systemUpgrade.complete.description' />
  </div>
);

export default SecEmeaCutover;
